// Get All Payments
export const GET_ALL_PAYMENTS_REQUEST = "GET_ALL_PAYMENTS_REQUEST"
export const GET_ALL_PAYMENTS_SUCCESS = "GET_ALL_PAYMENTS_SUCCESS"
export const GET_ALL_PAYMENTS_FAIL = "GET_ALL_PAYMENTS_FAIL"

// Get Payment by ID
export const GET_PAYMENT_BY_ID_REQUEST = "GET_PAYMENT_BY_ID_REQUEST"
export const GET_PAYMENT_BY_ID_SUCCESS = "GET_PAYMENT_BY_ID_SUCCESS"
export const GET_PAYMENT_BY_ID_FAIL = "GET_PAYMENT_BY_ID_FAIL"

// Get Payment Details by ID
export const GET_PAYMENT_DETAILS_BY_ID_REQUEST = "GET_PAYMENT_DETAILS_BY_ID_REQUEST"
export const GET_PAYMENT_DETAILS_BY_ID_SUCCESS = "GET_PAYMENT_DETAILS_BY_ID_SUCCESS"
export const GET_PAYMENT_DETAILS_BY_ID_FAIL = "GET_PAYMENT_DETAILS_BY_ID_FAIL"

// Add Payment
export const ADD_PAYMENT_REQUEST = "ADD_PAYMENT_REQUEST"
export const ADD_PAYMENT_SUCCESS = "ADD_PAYMENT_SUCCESS"
export const ADD_PAYMENT_FAIL = "ADD_PAYMENT_FAIL"

// Update Payment
export const UPDATE_PAYMENT_REQUEST = "UPDATE_PAYMENT_REQUEST"
export const UPDATE_PAYMENT_SUCCESS = "UPDATE_PAYMENT_SUCCESS"
export const UPDATE_PAYMENT_FAIL = "UPDATE_PAYMENT_FAIL"

// Delete Payment
export const DELETE_PAYMENT_REQUEST = "DELETE_PAYMENT_REQUEST"
export const DELETE_PAYMENT_SUCCESS = "DELETE_PAYMENT_SUCCESS"
export const DELETE_PAYMENT_FAIL = "DELETE_PAYMENT_FAIL"

// NEW: Add Payment Transaction
export const ADD_PAYMENT_TRANSACTION_REQUEST = "ADD_PAYMENT_TRANSACTION_REQUEST"
export const ADD_PAYMENT_TRANSACTION_SUCCESS = "ADD_PAYMENT_TRANSACTION_SUCCESS"
export const ADD_PAYMENT_TRANSACTION_FAIL = "ADD_PAYMENT_TRANSACTION_FAIL"

// NEW: Update Payment Balance
export const UPDATE_PAYMENT_BALANCE_REQUEST = "UPDATE_PAYMENT_BALANCE_REQUEST"
export const UPDATE_PAYMENT_BALANCE_SUCCESS = "UPDATE_PAYMENT_BALANCE_SUCCESS"
export const UPDATE_PAYMENT_BALANCE_FAIL = "UPDATE_PAYMENT_BALANCE_FAIL"